import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  FormGroup,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// actions
import {
  resetCompanies,
  resetError,
  getCompanies,
  activateCompany,
  cleanQueue,
  resetSuccess,
} from "../../store/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Moment
import Moment from "react-moment";

const Companies = ({ t }) => {
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const {
    dataCompany,
    dataCompanyActivate,
    loadingCompany,
    loadingCompanyActivate,
    errorCompany,
    successCompany,
    loadingCompanyCleanQueue,
    dataCompanyCleanQueue,
  } = useSelector((state) => state.Company);

  const { data } = useSelector((state) => state.Login);
  const cleanPermission = data?.permissions?.clean_queue_data;

  const [page, setPage] = useState(1);
  const [modalActive, setModalActive] = useState(false);
  const [modalClear, setModalClear] = useState(false);
  const [companyId, setCompanyId] = useState();
  const [companyName, setCompanyName] = useState();

  const [skillId, setSkillId] = useState();

  const [nameFilter, setNameFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [documentFilter, setDocumentFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const [active, setActive] = useState();
  const [status, setStatus] = useState();

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => {
      dataCompanyActivate
        ? dispatch(resetCompanies()) && handleFilter()
        : dispatch(resetSuccess());
    },
  };

  const handleFilter = (name, email, document) => {
    setNameFilter(name);
    setEmailFilter(email);
    setDocumentFilter(document);
    setPage(1);
    dispatch(getCompanies(1, qtdDefault, name, email, document));
  };

  const handleActivate = () => {
    dispatch(activateCompany(companyId, active));
  };

  const handleClear = () => {
    dispatch(cleanQueue(companyId, skillId));
  };

  const toggleModalActive = () => {
    setModalActive(!modalActive);
  };

  const toggleModalClear = () => {
    setModalClear(!modalClear);
  };

  const setCompanyIdName = (company) => {
    setCompanyId(company.id);
    setCompanyName(company.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(
      getCompanies(value, qtdDefault, nameFilter, emailFilter, documentFilter)
    );
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataCompany && dataCompany.paging) {
      if (page < dataCompany.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  useEffect(() => {
    setModalClear(false);
    if (dataCompanyActivate && dataCompanyActivate.message) {
      showToast("success", t(dataCompanyActivate.message));
    }
    if (dataCompanyCleanQueue) {
      showToast(
        "success",
        dataCompanyCleanQueue?.message + ` ${t("Conversations were removed")}`
      );
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successCompany]);

  useEffect(() => {
    setModalClear(false);
    if (errorCompany && typeof errorCompany === "object") {
      errorCompany.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "clients_id not found" &&
          showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorCompany) {
        showToast("error", t(errorCompany));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorCompany]);

  useEffect(() => {
    if (dataCompany !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataCompany]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/companies"
            title={t("Dashboard")}
            breadcrumbItem={t("Companies")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name, values.email, values.document);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Email")}
                            id="email"
                            name="email"
                            type="text"
                            className="form-control"
                            placeholder={t("Email") + "..."}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Document")}
                            id="document"
                            name="document"
                            type="text"
                            className="form-control"
                            placeholder={t("Document") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[()0-9-]*$/i", // only numbers, dots, slash and dashes
                                errorMessage: t(
                                  "Document must be composed only with numbers, dots and slashs"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 20,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="6"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-company">
                          <Link to="/company">
                            <Button
                              type="button"
                              color="success"
                              className="waves-effect waves-light w-100 mr-2"
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Company")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("Name")}</th>
                            <th>{t("Email")}</th>
                            <th>{t("Document")}</th>
                            <th>{t("Created in")}</th>
                            <th>{t("Status")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingCompany ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataCompany &&
                            dataCompany.clients &&
                            dataCompany.clients.length > 0 ? (
                            dataCompany.clients.map((company, key) => (
                              <tr key={key}>
                                <td>{company.name}</td>
                                <td>
                                  <Link
                                    to="#"
                                    className="text-body font-weight-bold"
                                  >
                                    {company.email}
                                  </Link>
                                </td>
                                <td>{company.document}</td>

                                <td>
                                  {
                                    <Moment format="DD/MM/YYYY">
                                      {company.created_at}
                                    </Moment>
                                  }
                                </td>
                                <td>
                                  <div
                                    className="custom-control custom-switch"
                                    dir="ltr"
                                  >
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id={"customSwitch" + company.id}
                                      readOnly
                                      checked={
                                        company.active === "1" ? true : false
                                      }
                                      onClick={() => {
                                        setCompanyIdName(company);
                                        toggleModalActive();
                                        setStatus(
                                          company.active === "1"
                                            ? t("deactivate")
                                            : t("activate")
                                        );
                                        setActive(
                                          company.active === "1"
                                            ? { active: false }
                                            : { active: true }
                                        );
                                      }}
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor={"customSwitch" + company.id}
                                    >
                                      {company.active === "1"
                                        ? t("Active")
                                        : t("Inactive")}
                                    </label>
                                  </div>
                                </td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Link
                                    to={`/company/${company.id}/users`}
                                    className="text-primary text-center d-flex"
                                  >
                                    <i
                                      className="bx bxs-user-detail font-size-18 px-2"
                                      id="agentstooltip"
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target="agentstooltip"
                                    >
                                      {t("Users")}
                                    </UncontrolledTooltip>
                                  </Link>
                                  <Link
                                    to={`/company/${company.id}`}
                                    className="text-primary text-center d-flex"
                                    id="edit"
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 px-2"
                                      id="edittooltip"
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target="edittooltip"
                                    >
                                      {t("Edit")}
                                    </UncontrolledTooltip>
                                  </Link>
                                  {cleanPermission && (
                                    <div
                                      className="text-primary text-center pointer d-flex"
                                      id="clean"
                                      onClick={() => {
                                        setCompanyIdName(company);
                                        toggleModalClear();
                                      }}
                                    >
                                      <i
                                        className="mdi mdi-broom font-size-18 px-2"
                                        id="cleantooltip"
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target="cleantooltip"
                                      >
                                        {t("Clear Queue")}
                                      </UncontrolledTooltip>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modalActive || loadingCompanyActivate}>
                        <div className="modal-body font-size-18 text-center">
                          {`${t("Do you want to")} ${status}`}
                          <strong> {companyName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModalActive}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingCompanyActivate ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModalActive();
                                if (companyId) handleActivate();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                      <Modal isOpen={modalClear || loadingCompanyCleanQueue}>
                        <AvForm onValidSubmit={handleClear}>
                          <div className="modal-body">
                            <div className="font-size-18 text-center mb-4">
                              {`${t("Do you want to clean the queue of")}`}
                              <strong> {companyName}</strong>?
                            </div>
                            <FormGroup className="px-3">
                              <AvField
                                value={skillId}
                                label={t("Skill id")}
                                name="skill_id"
                                type="text"
                                className="form-control"
                                placeholder={t("Enter skill id")}
                                onChange={(e) => {
                                  setSkillId(e.target.value || undefined);
                                }}
                              />
                            </FormGroup>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              onClick={toggleModalClear}
                              className="btn btn-danger waves-effect"
                              data-dismiss="modal"
                              style={{ backgroundColor: "#f14646" }}
                            >
                              {t("No")}
                            </button>
                            {loadingCompanyCleanQueue ? (
                              <button
                                type="button"
                                className="btn btn-secondary waves-effect waves-light"
                                disabled
                              >
                                <Spinner size="sm" animation="border" />
                              </button>
                            ) : (
                              <button
                                type="submit"
                                className="btn btn-secondary waves-effect waves-light"
                              >
                                {t("Yes")}
                              </button>
                            )}
                          </div>
                        </AvForm>
                      </Modal>
                    </PerfectScrollbar>
                  </div>

                  {dataCompany &&
                  dataCompany.paging &&
                  dataCompany.paging.length > 1 ? (
                    <Pagination className="pagination pagination-rounded justify-content-end my-2">
                      <PaginationItem onClick={handlePreviousPage}>
                        <PaginationLink previous />
                      </PaginationItem>

                      {dataCompany &&
                        dataCompany.paging &&
                        dataCompany.paging.map((value, index) => {
                          return (
                            <PaginationItem
                              key={index}
                              onClick={() => {
                                handlePage(value);
                              }}
                              active={page === value ? true : false}
                            >
                              <PaginationLink
                                key={index}
                                style={{ display: "inline" }}
                              >
                                {value}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        })}
                      <PaginationItem onClick={handleNextPage}>
                        <PaginationLink next />
                      </PaginationItem>
                    </Pagination>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Companies);
